/**
 * Harvest Mate - OEM Connection API
 *
 * Contact: servicedesk@clevvi.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Per-organisation grant lifecycle state.
 */
export const GrantState = {
    Pending: 'pending',
    Granted: 'granted',
    Revoked: 'revoked'
} as const;
export type GrantState = typeof GrantState[keyof typeof GrantState];

